/**
 * Created by wuhuping on 2017/11/15.
 */
import Instance from './resource'
export default {
  // 获取福利模块数据
  welfareBannerList(data) {
    return Instance.post('prod/welfareBannerList', data);
  }
}



// WEBPACK FOOTER //
// ./src/api/welfare.js